import { useLoginUser } from './useLoginUser';
import { useLoginCypress } from './useLoginCypress';

export const useLogin = !window.Cypress ? useLoginUser : useLoginCypress;
